// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"399":"f4f60de6","453":"68693753","529":"24b4f9e7"}[chunkId] + ".chunk.js";
};